import React from "react";
import Image from "../../assets/img/background.webp";
// import icons

const Hero = () => {
  return (
    <section
      className="w-screen h-screen bg-cover bg-center z-0 flex items-center justify-center"
      style={{ backgroundImage: `url(${Image})` }}
    >
      <div id="home" className="text-center flex flex-col items-center justify-center h-full">
        {/* title */}
        <h1
          className="text-[32px] lg:text-[64px] leading-tight mb-6 text-black"
          data-aos="slide-down"
          data-aos-delay="400"
        >
          Powering a sustainable future
        </h1>
        <p
          className="max-w-[540px] leading-relaxed mb-8 mx-auto text-[16px] lg:text-[32px] text-slate-600"
          data-aos="slide-down"
          data-aos-delay="450"
        >
          one property at a time.
        </p>
        <a
          href="/" // Replace with your desired URL
          target="_blank" // Opens the link in a new tab
          rel="noopener noreferrer" // Security best practice for external links
          className="bg-blue-400 px-6 py-4 rounded-full text-slate-600 text-sm lg:h-16 lg:text-base font-bold gap-x-6 inline-block items-center justify-center text-center"
        >
          Get Started Now!
        </a>
      </div>
    </section>
  );
};

export default Hero;
